import React from 'react';
import { IOrderParams } from '../../../API/pcDashboard/getOrderAsync';
import { DashboardFilterForm } from './filterForm/DashboardFilterForm';
import { Flex } from '@zillow/constellation';
import { CustomViewsContainer } from './customViews/CustomViewsContainer';
import { ErrorBoundaryConstellation } from '../../../constellationExtended/ErrorBoundary/ErrorBoundaryConstellation';

export const DashboardFiltersContainer: React.FC<{
  queryObject: IOrderParams;
  setQueryObject: (queryObject: IOrderParams) => void;
}> = ({ queryObject, setQueryObject }) => {
  return (
    <ErrorBoundaryConstellation>
      <Flex display={'flex'} flexDirection={'column'} gap={'md'}>
        <DashboardFilterForm queryObject={queryObject} setQueryObject={setQueryObject} />
        <CustomViewsContainer />
      </Flex>
    </ErrorBoundaryConstellation>
  );
};
